import React from "react";
import { FormControl } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: "100%",
    },
    CommonSelect: {
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

interface Props {
  inputLabel: string;
  name: string;
  allValues: any;
  value: string;
  onChange: any;
  cssClassName?: string;
  style?: any;
  // onChange?:
  //   | ((
  //       event: React.ChangeEvent<{
  //         name?: string | undefined;
  //         value: unknown;
  //       }>,
  //       child: React.ReactNode
  //     ) => void)
  //   | undefined;
}

export default function CommonSelect({
  inputLabel,
  name,
  allValues,
  value,
  onChange,
  cssClassName,
  style,
}: Props) {
  const classes = useStyles();
  // const [userGroup, setUserGroup] = React.useState("");

  // const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   setUserGroup(event.target.value as string);
  // };

  return (
    <div>
      <FormControl
        variant="outlined"
        size="small"
        className={`${classes.formControl} ${cssClassName}`}
      >
        <InputLabel id="demo-simple-select-outlined-label">{inputLabel}</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          // id="demo-simple-select-outlined"
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={`${classes.CommonSelect}`}
          label={inputLabel}
          style={style}
        >
          {allValues.map((item: any, i: any) => (
            <MenuItem
              key={i}
              value={item.value}
              // {/* Commented out before UAT */}
              // style={{ background: item.backgroundColor, color: item.textColor }}
              // {/* Commented out before UAT */}
            >
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
